// extracted by mini-css-extract-plugin
export default {"Trust":"Trust_Trust__t+1is","Title":"Trust_Title__deQre","Image":"Trust_Image__7tQI2"};